module.exports = __webpack_public_path__ + "static/img/offical10.ac707bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/joinus/offical10.jpg
// module id = Lo2A
// module chunks = 18